import { render } from "./admin-equipment-list.vue?vue&type=template&id=553888ca&ts=true"
import script from "./admin-equipment-list.vue?vue&type=script&lang=ts"
export * from "./admin-equipment-list.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__